import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { clsx } from 'clsx';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const DropZone = ({ onFileSelect }) => {
  const onDrop = useCallback(acceptedFiles => {
    if (acceptedFiles?.length > 0) onFileSelect(acceptedFiles[0]);
  }, [onFileSelect]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'image/jpeg': [], 'image/png': [], 'image/webp': [], 'image/tiff': [] },
    multiple: false
  });

  return (
    <div {...getRootProps()} className={clsx(
      "border-2 border-dashed rounded-3xl p-16 text-center cursor-pointer transition-all duration-500",
      isDragActive ? "border-blue-500 bg-blue-500/5 scale-[1.01]" : "border-slate-800 hover:border-slate-700 bg-slate-950/50"
    )}>
      <input {...getInputProps()} />
      <div className="flex flex-col items-center gap-6">
        <div className={clsx(
          "w-20 h-20 rounded-2xl flex items-center justify-center transition-all shadow-2xl",
          isDragActive ? "bg-blue-600 text-white" : "bg-slate-900 text-slate-500"
        )}>
          <SafeIcon icon={FiIcons.FiUploadCloud} className="text-4xl" />
        </div>
        <div>
          <p className="text-xl font-black text-white tracking-tight">
            {isDragActive ? "DEPLOY NEURAL SCAN..." : "DROP IMAGE FOR INVESTIGATION"}
          </p>
          <p className="text-slate-500 mt-2 font-bold text-xs uppercase tracking-widest">
            JPEG • PNG • WEBP • TIFF
          </p>
        </div>
      </div>
    </div>
  );
};

export default DropZone;